import { render, staticRenderFns } from "./TbColumns.vue?vue&type=template&id=6a655681&scoped=true"
import script from "./TbColumns.vue?vue&type=script&lang=js"
export * from "./TbColumns.vue?vue&type=script&lang=js"
import style0 from "./TbColumns.vue?vue&type=style&index=0&id=6a655681&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a655681",
  null
  
)

export default component.exports